import Constants from "~/helpers/enums/Constants";

const changeTabValue = (value) => (dispatch) => {
	dispatch({ type: Constants.CHANGE_TAB_VALUE, payload: { value } });
};

export default {
	changeTabValue,
};
